import axios from "axios";
import Config from "../utils/Config";

class WorkflowService {
    config = {
        headers: {
            Authorization: "",
            CompanyId: "",
        },
    };

    config2 = {
        headers: {
            Authorization: "",
            CompanyId: "",
            'Content-Type': 'multipart/form-data'
        },
    };



    setAccessToken(accessToken, companyId) {
        this.config.headers.Authorization = accessToken;
        this.config.headers.CompanyId = companyId;


        this.config2.headers.Authorization = accessToken;
        this.config2.headers.CompanyId = companyId;
        // this.config.headers.Authorization = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJfaWQiOiI2NjU0NzhjOGVkMTA1OTI3YmIxMDhlZjIiLCJlbWFpbCI6InRodXNoYXJhLmthcnVuYXNlbmFAc3luYXBzeXMubGsiLCJpc0ZpcnN0VGltZSI6ZmFsc2UsInN0YXR1cyI6dHJ1ZSwiY29tcGFueURhdGEiOlt7ImNvbXBhbnlJZCI6IjY2M2I1Njc4OWM5MzU4ODJkMzFhOTJjMiIsInVzZXJEZXRhaWxzSWQiOiI2NjNiNTZkNDljOTM1ODgyZDMxYTkyZDAiLCJuYW1lIjoiVGh1c2hnZ2dnYXJlYSBkZSBQZXJlcmEiLCJjb21wYW55TmFtZSI6IlRodXNoYXJhJ3MgQ29tcGFueSIsInN0YXR1cyI6dHJ1ZSwidGhlbWVDb2xvciI6IjRhMjM1YSIsInJvbGVzIjpbeyJyb2xlSWQiOiI2NjNiNTY3ODljOTM1ODgyZDMxYTkyYzQiLCJyb2xlTmFtZSI6IkNvbXBhbnkgQWRtaW4iLCJyZXN0cmljdGVkIjp0cnVlfSx7InJvbGVJZCI6IjY2M2I1Njc4OWM5MzU4ODJkMzFhOTJjNiIsInJvbGVOYW1lIjoiU2VjcmV0YXJ5IiwicmVzdHJpY3RlZCI6dHJ1ZX1dfSx7ImNvbXBhbnlJZCI6IjY2M2I4NWNmMTY4YTdmOWUzNDJhZTJjZCIsInVzZXJEZXRhaWxzSWQiOiI2NmFiY2NmYzlmNTJkYjgwMWY2YTg5ZTMiLCJuYW1lIjoiVGh1c2hhcmEiLCJjb21wYW55TmFtZSI6IlNZTkFQU1lTIiwic3RhdHVzIjp0cnVlLCJ0aGVtZUNvbG9yIjoiI0ZGRkYwMCIsInJvbGVzIjpbeyJyb2xlSWQiOiI2NjNiODVkMDE2OGE3ZjllMzQyYWUyZDEiLCJyb2xlTmFtZSI6IlNlY3JldGFyeSIsInJlc3RyaWN0ZWQiOnRydWV9LHsicm9sZUlkIjoiNjYzYjg1ZDAxNjhhN2Y5ZTM0MmFlMmNmIiwicm9sZU5hbWUiOiJDb21wYW55IEFkbWluIiwicmVzdHJpY3RlZCI6dHJ1ZX1dfSx7ImNvbXBhbnlJZCI6IjY2Yjk4YzQxNTRmMTAyNzg2YmUwYzYxOSIsInVzZXJEZXRhaWxzSWQiOiI2NmI5OGQ4NzU0ZjEwMjc4NmJlMGM2NmUiLCJuYW1lIjoiVGh1c2hhcmEgS2FydW5hc2VuYSIsImNvbXBhbnlOYW1lIjoiU3luYXBzeXNMSyIsInN0YXR1cyI6dHJ1ZSwidGhlbWVDb2xvciI6IiNGRkZGMDAiLCJyb2xlcyI6W3sicm9sZUlkIjoiNjZiOThjNDE1NGYxMDI3ODZiZTBjNjIzIiwicm9sZU5hbWUiOiJHZW5lcmFsIFVzZXIiLCJyZXN0cmljdGVkIjp0cnVlfV19LHsiY29tcGFueUlkIjoiNjcwZTFlNzU4YzFhOWZmYjQyMmFiMGRiIiwidXNlckRldGFpbHNJZCI6IjY3MGUzMGViZDQ3NWZjYWNiMWUwOWM2NCIsIm5hbWUiOiJTZWNyZXRhcnkgdXNlciAyIiwiY29tcGFueU5hbWUiOiJBQkMgY29tcGFueSIsInN0YXR1cyI6dHJ1ZSwidGhlbWVDb2xvciI6IiNGRkZGMDAiLCJyb2xlcyI6W3sicm9sZUlkIjoiNjcwZTFlNzY4YzFhOWZmYjQyMmFiMGRmIiwicm9sZU5hbWUiOiJTZWNyZXRhcnkiLCJyZXN0cmljdGVkIjp0cnVlfV19XSwiaWF0IjoxNzM4MDM0NzAyLCJleHAiOjE3MzgwNjM1MDJ9.mpdYUIoWVX8BdGcQnQrL-ESBEfN1e4OwaPQ9szfgmb0';
        // //this.config.headers.CompanyId = '674815a15748d3764fb52438';
        // this.config.headers.CompanyId = '663b56789c935882d31a92c2';
        // //this.config.headers.CompanyId = '663b85cf168a7f9e342ae2cd';

    }

    async getApprovalRequests(statusId, companyId, accessToken) {
        this.setAccessToken(accessToken, companyId);
        const data = await axios.get(
            Config.BACKEND_URL + `/api/approvalRequest/getApprovalRequestsForLoggedUserByStatus?status=${statusId}`,
            this.config
        )
        return data.data;
    }

    async getToDoRequests(companyId, accessToken) {
        this.setAccessToken(accessToken, companyId);
        const data = await axios.get(
            Config.BACKEND_URL + '/api/approvalRequest/getTodoApprovalRequestsForLoggedUser',
            this.config
        )
        return data.data;
    }

    async getAdHocUsers(userId, companyId, accessToken) {
        this.setAccessToken(accessToken, companyId);
        const data = await axios.get(
            Config.BACKEND_URL + `/api/signatories/userId/${userId}`,
            this.config
        )
        return data.data;
    }

    async postComments(approvalRequestId, companyId, accessToken, formData) {
        this.setAccessToken(accessToken, companyId);
        const data = await axios.patch(
            Config.BACKEND_URL + `/api/approvalRequest/${approvalRequestId}/comments`,
            formData,
            this.config2
        )
        return data.data;
    }

    async approve(approvalRequestId, approverId, companyId, accessToken, formData) {
        this.setAccessToken(accessToken, companyId);
        const data = await axios.patch(
            Config.BACKEND_URL + `/api/approvalRequest/${approvalRequestId}/approvers/${approverId}`,
            formData,
            this.config
        )
        return data.data;
    }

    async addHocUser(approvalRequestId, approverId, companyId, accessToken, formData) {
        this.setAccessToken(accessToken, companyId);
        const data = await axios.patch(
            Config.BACKEND_URL + `/api/approvalRequest/${approvalRequestId}/addHockUser/${approverId}`,
            formData,
            this.config
        )
        return data.data;
    }

    async getUserLevelList(approvalRequestId, parenId, companyId, accessToken) {
        this.setAccessToken(accessToken, companyId);
        const data = await axios.get(
            Config.BACKEND_URL + `/api/approvalRequest/${approvalRequestId}/getTargetApproversForNeedMoreInfo/${parenId}`,
            this.config
        )
        return data.data;
    }

    async setArchiveUnarchive(approvalRequestId, formData, companyId, accessToken) {
        this.setAccessToken(accessToken, companyId);
        const data = await axios.patch(
            Config.BACKEND_URL + `/api/approvalRequest/${approvalRequestId}/action`,
            formData,
            this.config
        )
        return data.data;
    }

    async deleteApprovalRequest(approvalRequestId, companyId, accessToken) {
        this.setAccessToken(accessToken, companyId);
        const data = await axios.delete(
            Config.BACKEND_URL + `/api/approvalRequest/${approvalRequestId}`,
            this.config
        )
        return data.data;
    }

    async updateApproverViewStatus(approvalRequestId, parentId, companyId, accessToken, formData) {
        this.setAccessToken(accessToken, companyId);
        const data = await axios.patch(
            Config.BACKEND_URL + `/api/approvalRequest/${approvalRequestId}/updateApproverViewStatus/${parentId}`,
            formData,
            this.config
        )
        return data.data;
    }

    async downloadSingleFile(approvalRequestId, documentId, companyId, accessToken) {
        this.setAccessToken(accessToken, companyId);
        const { data } = await axios.get(
            Config.BACKEND_URL + `/api/approvalRequest/download/${approvalRequestId}/document/${documentId}`,
            { ...this.config, responseType: 'arraybuffer' } // Handle binary data
        );
        return data;
    }


    async downloadAllFiles(approvalRequestId, companyId, accessToken) {
        this.setAccessToken(accessToken, companyId);
        const { data } = await axios.get(
            Config.BACKEND_URL + `/api/approvalRequest/downloadAllDocuments/${approvalRequestId}`,
            { ...this.config, responseType: 'arraybuffer' }
        );
        return data;
    }

    async getUsersByCompanyId(companyId, accessToken) {
        this.setAccessToken(accessToken, companyId);
        const data = await axios.get(
            Config.BACKEND_URL + '/api/userDetails/usersByCompanyId',
            this.config
        )
        return data.data;
    }
}


export default new WorkflowService();

